import { render, staticRenderFns } from "./VideoInstructionStep.vue?vue&type=template&id=d546e304&scoped=true"
import script from "./VideoInstructionStep.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoInstructionStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VideoInstructionStep.vue?vue&type=style&index=0&id=d546e304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d546e304",
  null
  
)

export default component.exports